import { type ReactElement } from 'react'
import { Size } from '@front/model'
import { Stack, Group, Text } from '@mantine/core'
import { OptimisticPermissionButton } from 'app/components'
import { useTeamHierarchyContext } from '../../TeamHierarchyContext'
import { ButtonVisibility } from '../ButtonVisibility'
import { type TeamNodeContentProps } from './types'

export const PermissionNode = ({ team }: TeamNodeContentProps): ReactElement => {
  const { collapsedTeams, toggleTeamCollapse } = useTeamHierarchyContext()

  const handleToggleVisibility = (): void => {
    toggleTeamCollapse(team.teamId)
  }

  return (
    <Stack>
      <Text className='text-center'>{team.name}</Text>
      <Group gap={Size.space.lg} justify='center' onClick={(e) => e.stopPropagation()}>
        <ButtonVisibility isHiding={collapsedTeams.includes(team.teamId)} onClick={handleToggleVisibility} />
        <OptimisticPermissionButton
          buttonProps={{ buttonType: 'icon-rounded' }}
          entityId={team.teamId}
          drawerTitle={
            <>
              Permissions for all users in{' '}
              <Text inherit span c='brand'>
                {team.name}
              </Text>
            </>
          }
        />
      </Group>
    </Stack>
  )
}
